module.exports = __webpack_public_path__ + "static/img/2-1.fd1d03e6.png";